<template>
  <b-form-datepicker
    v-bind="{ ...$attrs, ...$t('calendar') }"
    :locale="$i18n.locale"
    :placeholder="$attrs.placeholder || $t('calendar.labelNoDateSelected')"
    v-on="$listeners"
  />
</template>

<script>
import { BFormDatepicker } from 'bootstrap-vue'

export default {
  components: { BFormDatepicker },
  inheritAttrs: false,
}
</script>
